import axios from "axios";

/**
 * @typedef {Object} ConnectorSessionDto
 * @property {string} id - Firestore document ID
 * @property {string} connectorId - Connector Firestore reference
 * @property {string} [userGroupId] - User group Firestore reference
 * @property {string} [userId] - User Firestore reference (may be null if organization based)
 * @property {string} jwt - JWT token for authentication
 * @property {Date} [expiresAt] - Token expiration date
 */

const connectorService = {
	/**
	 * Create a new connector session
	 * @param {string} type - Connector type (e.g., "novologik")
	 * @returns {Promise<ConnectorSessionDto>} Connector session with JWT
	 */
	async createSession(type) {
		try {
			const { data } = await axios.post(`connectors/login/${type}`);

			console.log(`[CONNECTOR-${type.toUpperCase()}] Login successful:`, data);
			return data;
		} catch (error) {
			console.error(`[CONNECTOR-${type.toUpperCase()}] Failed to create session:`, error);
			throw error;
		}
	},

	/**
	 * Get existing connector session
	 * @param {string} sessionId - Session ID
	 * @returns {Promise<ConnectorSessionDto>} Connector session
	 */
	async getSession(sessionId) {
		try {
			const { data } = await axios.get(`connectors/sessions/${sessionId}`);

			return data;
		} catch (error) {
			console.error("[CONNECTOR] Failed to get session:", error);
			throw error;
		}
	}
};

export default connectorService;
